import { InitState } from '../../reducers/root/initialState'
import { PriceMaximizerInput } from '../../../@types/price-maximizer-types'
import { DispatchType } from '../../../@types/redux-types'
import { loadPriceMaximizer } from './priceMaximizer'
import { ContentStateInterface } from '../../../@types/types'
import { getValidationInvalid } from '../../../services/validation/validationService'
import {
  BasicInfoScreenValidationResult,
  ScreenValidationResult,
  ValidationResult,
  ValidationSchema,
  ValidationStructure,
} from '../../../@types/validation-types'
import { priceToApiRent } from '../../../api/realEstate/converters/toApi/estate/price/priceToApi'
import { detailsToApi } from '../../../api/realEstate/converters/toApi/estate/details/detailsToApi'
import { getDefaultLogger } from '../../../services/logger/logger'
import { AddressFeatureState } from '../../../@types/state-types'
import { runValidation } from '../../../services/validation/editor/runValidation'
import { geoCoordinatesToApi } from '../../../api/realEstate/converters/toApi/estate/address/geoCoordinates/geoCoordinatesToApi'

export const fetchPriceMaximizerDataIfValid =
  (insertionData: ContentStateInterface, addressFeature: AddressFeatureState, validationSchema: ValidationSchema) =>
  async (dispatch: DispatchType, getState: () => InitState) => {
    const flowInformation = getState().flowFeature.flowInformation

    const priceMaximizerSchema: ValidationSchema = {
      address: validationSchema.address,
      basicInfo: validationSchema.basicInfo,
      costs: validationSchema.costs,
      otherFacilities: validationSchema.otherFacilities,
    }
    const validationResult = runValidation(insertionData, addressFeature, priceMaximizerSchema)
    const isValidationInvalid = getValidationInvalid<
      ValidationResult,
      ScreenValidationResult<BasicInfoScreenValidationResult>
    >(validationResult, (value) => value.fields as ValidationStructure)
    if (
      isValidationInvalid ||
      addressFeature.geoCoordinates.longitude === 0 ||
      addressFeature.geoCoordinates.latitude === 0
    ) {
      return
    }
    // Price maximizer is not available for international addresses
    if (addressFeature.isInternationalAddress) {
      return
    }

    try {
      const { category, transaction } = flowInformation.metaData
      const price = (flowInformation.priceToApiMapper ?? priceToApiRent)(insertionData).price
      const { livingSpace, noRooms, plotArea } = detailsToApi(insertionData)
      if (!category || !livingSpace || !noRooms || !price) {
        return
      }
      const geoCoordinates = geoCoordinatesToApi(addressFeature, insertionData)
      const priceMaximizerInputs: PriceMaximizerInput = {
        category,
        transaction,
        geoCoordinates,
        livingSpace,
        noRooms,
        price,
        plotArea,
      }
      await loadPriceMaximizer(priceMaximizerInputs)(dispatch)
    } catch (e) {
      getDefaultLogger().warn('Failed to load price maximizer inputs. Failed to transform data to api.', e)
      return
    }
  }
